import React, { useEffect } from 'react';
import BuildingInfo from './BuildingInfo';

const Tenants = () => {
    return <BuildingInfo type='Tenant'/>;
};

export default Tenants;
